import { ApiError } from '@/config/api'

type FormError = {
  key: string
  messages: string[]
}

type KeyMap<T> = {
  [key in keyof T]?: string
}

function toStringWithoutRepeat(errors: string[] | undefined) {
  return [...new Set(errors?.map((message) => message))].join(' ')
}

function handleErrors<T>(
  data: ApiError | undefined,
  keys: (keyof T)[],
  callbackFn: (props: string) => void,
  aliasMap?: KeyMap<T>,
) {
  const errors = data?.errors

  if (!errors || errors.message?.length) {
    callbackFn(
      toStringWithoutRepeat(errors?.message) ||
        data?.message ||
        'Ocorreu um erro na aplicação.',
    )
  }

  return Object.entries(errors ?? [])
    .filter(
      ([key]) =>
        keys.includes(key as keyof T) ||
        Object.values(aliasMap ?? {}).includes(key),
    )
    .map(([key, messages]) => ({
      key: aliasMap
        ? (keys.find((k) => k === key || aliasMap[k] === key) as keyof T)
        : key,
      messages: messages || [],
    }))
}

export { toStringWithoutRepeat, handleErrors, type FormError }
